var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"owal-list-section__header",on:{"click":_vm.clicked}},[_vm._v("\n  "+_vm._s(_vm.title)+"\n  "),_c('owal-list-row-accessory',{class:("" + (this.collapsed ? 'owal-list__accessory_collapsed' : 'owal-list__accessory'))})],1)}
var staticRenderFns = []

export { render, staticRenderFns }